import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Step, StepStatus } from 'src/app/core/steps.service';
import { UtilsService } from 'src/app/core/utils.service';
import { StepsQineticReloadDialogComponent } from 'src/app/steps/steps-qinetic-reload-dialog/steps-qinetic-reload-dialog.component';
import { StepsRequestsDialogComponent } from 'src/app/steps/steps-requests-dialog/steps-requests-dialog.component';

@Component({
  selector: 'app-order-details-installments-info',
  templateUrl: './order-details-installments-info.component.html',
  styleUrls: ['./order-details-installments-info.component.scss'],
})
export class OrderDetailsInstallmentsInfoComponent {
  @Input() steps?: Step[];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  completed_step_status: StepStatus = StepStatus.completed;

  constructor(
    private utils_service: UtilsService,
    private dialog_service: DialogService,
    private error_service: ErrorService,
  ) {}

  getSortedSteps(): Step[] {
    if (!this.steps) {
      return [];
    }
    return [...this.steps].sort((a, b) => {
      const index_a = a.index ?? Infinity;
      const index_b = b.index ?? Infinity;

      return index_a - index_b;
    });
  }

  getCurrencyLabel(step: Step): string {
    return this.utils_service.getCurrencyLabelFromStep(step);
  }

  getStepStatusClass(status?: StepStatus): string {
    if (status) {
      return this.utils_service.getStepStatusClass(status);
    } else {
      return '';
    }
  }

  getStepStatusLabel(status?: StepStatus): string {
    return this.utils_service.getStepStatusLabel(status);
  }

  onQineticReloadClick(step: Step): void {
    this.dialog_service
      .openDialog(StepsQineticReloadDialogComponent, { step })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onRequestsClick(step: Step): void {
    this.dialog_service.openDialog(StepsRequestsDialogComponent, {
      buyer_id: step.buyer_id,
      step_id: step.step_id,
    });
  }
}
